import { render, staticRenderFns } from "./industryModeNew.vue?vue&type=template&id=b59c33b6&scoped=true&"
import script from "./industryModeNew.vue?vue&type=script&lang=js&"
export * from "./industryModeNew.vue?vue&type=script&lang=js&"
import style0 from "./industryModeNew.vue?vue&type=style&index=0&id=b59c33b6&lang=scss&scoped=true&"
import style1 from "./industryModeNew.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59c33b6",
  null
  
)

export default component.exports